import { AutocompleteType, postDapiStationMapAutoComplete } from "api"
import { LocationContext } from "contexts/LocationProvider"
import { useSearchParams } from "next/navigation"
import { useContext, useEffect } from "react"

export const useGetLocatorQueryParams = () => {

  const searchParams = useSearchParams()

  const { setSelectedCity, updateFilters, setSearchValue, isMapLoaded } =
    useContext(LocationContext)

  const searchCityFromParams = async (term: string) => {
    const res = await postDapiStationMapAutoComplete("", {
      Term: term,
      LocationLat: 0,
      LocationLng: 0,
      MaxResults: 50,
    })
    const { cities } = res.data.Body.body
    if (cities && cities.length > 0) {
      setSelectedCity({
        id: cities[0].id,
        type: AutocompleteType.City,
        name: term,
      })
    }
  }

  // handle query params
  useEffect(() => {
    if (!searchParams || !isMapLoaded) {
      return
    }
    const searchString = searchParams.get("search")
    const homepageString = searchParams.get("searchString")
    const metadata = searchParams.get("metadata")
    const locationlat = searchParams.get("locationlat")
    const locationlng = searchParams.get("locationlng")
    const cityid = searchParams.get("cityid")
    const stationid = searchParams.get("stationid")
    if (searchString) {
      setSearchValue(searchString)
    }
    if (metadata) {
      const metadataArray: number[] = JSON.parse(metadata)
      const filters = metadataArray.map((id) => ({
        id,
        name: "",
        value: "",
        image: "",
        imageSelected: "",
        category: "",
      }))
      updateFilters(filters)
    }
    if (locationlat && locationlng) {
      setSelectedCity({
        id: stationid ? parseInt(stationid) : 0,
        type: AutocompleteType.Station,
        name: searchString || "",
        geoLocation: {
          latitude: parseFloat(locationlat),
          longitude: parseFloat(locationlng),
        },
      })
    }
    if (cityid) {
      setSelectedCity({
        id: parseInt(cityid),
        type: AutocompleteType.City,
        name: searchString || "",
      })
    }
    if (homepageString) {
      setSearchValue(homepageString)
      searchCityFromParams(homepageString)
    }
  }, [isMapLoaded])
}

export const getLocatorQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const searchString = searchParams.get("search");
  const homepageString = searchParams.get("searchString");
  const metadata = searchParams.get("metadata");
  const locationlat = searchParams.get("locationlat");
  const locationlng = searchParams.get("locationlng");
  const cityid = searchParams.get("cityid");
  const stationid = searchParams.get("stationid");

  return {
    searchString,
    homepageString,
    metadata: metadata ? JSON.parse(metadata) : null,
    locationlat: locationlat ? parseFloat(locationlat) : null,
    locationlng: locationlng ? parseFloat(locationlng) : null,
    cityid: cityid ? parseInt(cityid, 10) : null,
    stationid: stationid ? parseInt(stationid, 10) : null,
  };
};
